import React, { useId } from 'react';

/** Native, visible choices: Enter also commits without submitting the enclosing form. */
export default function ChoiceField({ label, value, options, onChange, disabled = false, required = false, help }) {
  const id = useId();
  return <fieldset disabled={disabled} aria-describedby={help ? `${id}-help` : undefined} className="min-w-0 space-y-2">
    <legend className="text-sm font-semibold text-foreground">{label}{required && <span aria-hidden="true"> *</span>}</legend>
    {help && <p id={`${id}-help`} className="text-sm text-muted-foreground">{help}</p>}
    <div className="flex flex-wrap gap-2">{options.map(([key, text]) => <label key={key} className="flex min-h-11 cursor-pointer items-center gap-2 rounded-lg border border-input bg-background px-3 py-2 text-sm text-foreground has-[:checked]:ring-2 has-[:checked]:ring-ring">
      <input type="radio" name={id} value={key} required={required} checked={String(value) === String(key)} onChange={() => onChange(key)} onKeyDown={event => { if (event.key === 'Enter') { event.preventDefault(); onChange(key); } }} className="h-5 w-5 shrink-0 accent-teal-700" />
      <span>{text}</span>
    </label>)}</div>
  </fieldset>;
}
